// import '../css/MangalaPage.css';
import '../css/MangalaPage.css';
import logo from '../../assets/images/MangalaLogo.png';
import colorBgLogo from '../../assets/images/MangalaForColorBG.png';

import { Button, Carousel, Col, Container, Image, Row } from "react-bootstrap";


import floorPlanImg from '../../assets/images/CPR_MANGALA/mangala-floor-plan-layout.webp';
import landscapeGreenery from '../../assets/images/CPR_MANGALA/landscapeGreenery.webp';


import clubhouseImg from '../../assets/images/CPR_MANGALA/clubhouse.webp';
import bannerImg from '../../assets/images/CPR_MANGALA/bannerImg.webp'
import bannerImgTwo from '../../assets/images/CPR_MANGALA/bannerImgTwo.webp'


import { faArrowRight, faBuilding, faLayerGroup, faExpand, faCompass, faShield, faLeaf, faBasketballBall, faChild, faWalking, faPhoneAlt, faHeartPulse, faHandsPraying, faGlassCheers, faUsers, faDumbbell, faGamepad, faSpa, faCouch, faBriefcase, faCircleCheck, faDroplet, faShieldHalved, faVideo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { FloatButton, Masonry, Modal } from 'antd';


// Amenities images for wellness section
import banquetHall from '../../assets/images/CPR_MANGALA/amenities/banquet-hall.webp';
import tableGames from '../../assets/images/CPR_MANGALA/amenities/board&table-games.webp';


import desinger_landscape from '../../assets/images/CPR_MANGALA/amenities/designer_landscape.webp';
import gym from '../../assets/images/CPR_MANGALA/amenities/gym.webp';
import joggingTrack from '../../assets/images/CPR_MANGALA/amenities/jogging-track.webp';
import spa from '../../assets/images/CPR_MANGALA/amenities/spa&wellness.webp';
import libraryRoom from '../../assets/images/CPR_MANGALA/amenities/libraryRoom.webp';
import securitySystem from '../../assets/images/CPR_MANGALA/amenities/securitySystem.webp';

import { PhoneOutlined, WhatsAppOutlined } from '@ant-design/icons';

import CPR_Mangala_Brochure from '../../assets/docs/CPR_Mangala_Brochure.pdf';
import { Link, useNavigate } from 'react-router-dom';
import MetaHelper from '../MetaHelper';


const MangalaPage = () => {
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [hasAutoPopped, setHasAutoPopped] = useState(false);
    

    const [masonryColumns, setMasonryColumns] = useState(window.innerWidth < 768 ? 2 : 4);

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        interest: '2 BHK Independent Flat', // Default value
        message: ''
    });
    const [formStatus, setFormStatus] = useState({ type: '', message: '' });

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        if (name === 'phone') {
            const onlyNums = value.replace(/[^0-9]/g, ''); // Remove anything not a number
            if (onlyNums.length <= 10) {
                setFormData(prev => ({ ...prev, [name]: onlyNums }));

                // Clear the error message if they are typing a valid-ish sequence
                if (formStatus.message === 'Please enter a valid 10-digit phone number.') {
                    setFormStatus({ type: '', message: '' });
                }
            }
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    // This is for contact section's for at the bottom of the page
    const handleFormSubmit = async (e) => {
        e.preventDefault();

        // VALIDATION
        if(formData.phone.length !== 10) {
            setFormStatus({type: 'error', message: 'Please enter a valid 10-digit phone number.'});
            return;
        }

        setFormStatus({ type: 'loading', message: 'Sending inquiry...' });

        try {
            const response = await fetch('mangala-contact.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({...formData, source: 'CPR Mangala - From Contact Form'}),
            });
            
            const result = await response.json();

            if (result.status === 'success') {
                setFormStatus({ type: 'success', message: result.message });
                setFormData({ name: '', email: '', phone: '', interest: '2 BHK Independent Flat', message: '' });
                navigate('/cpr-mangala/thank-you', {
                    state: {
                        project: 'CPR Mangala',
                        returnPath: '/cpr-mangala'
                    }
                });

            } else {
                setFormStatus({ type: 'error', message: result.message });
            }
        } catch (error) {
            setFormStatus({ type: 'error', message: 'Network error. Please try again later.' });
        }
    };

    const handleBrochureSubmit = async (e) => {
        e.preventDefault();

        // VALIDATION
        if(formData.phone.length !== 10) {
            setFormStatus({type: 'error', message: 'Please enter a valid 10-digit phone number.'});
            return;
        }
        setFormStatus({ type: 'loading', message: 'Processing your request...' });

        // Local function to handle UI cleanup
        const finalizeRequest = () => {
            setIsModalOpen(false); // Closes the modal
            // Resets the form so it's empty next time you open it
            setFormData({ name: '', email: '', phone: '', interest: '2 BHK Independent Flat', message: '' });
            
            // Trigger the Download
            const link = document.createElement('a');
            link.href = CPR_Mangala_Brochure;
            link.download = 'CPR_Mangala_Brochure.pdf';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            navigate('/cpr-mangala/thank-you', {
                state: {
                    project: 'CPR Mangala',
                    returnPath: '/cpr-mangala'
                }
            });
        };

        try {
            const response = await fetch('mangala-contact.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ ...formData, interest: 'Brochure Download Request', source: 'CPR Mangala - From Brochure Download / Popup Form' }),
            });
            
            const result = await response.json();

            if (result.status === 'success') {
                finalizeRequest();
                setFormStatus({ type: 'success', message: 'Thank you! Download started.' });
            } else {
                setFormStatus({ type: 'error', message: result.message });
            }
        } catch (error) {
            console.error("Local environment: PHP not found");
            // FALLBACK: Allow it to close and download for local testing
            finalizeRequest();
            setFormStatus({ type: 'success', message: 'Offline Mode: Download triggered.' });
        }
    };

    const handleBrochureClick = (e) => {
        if (e) e.preventDefault();
        setFormData(prev => ({ ...prev, interest: 'Brochure Download Request' }));
        setIsModalOpen(true);
    };

    useEffect(() => {
        const handleResize = () => {
            setMasonryColumns(window.innerWidth < 768 ? 2 : 4);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);



    useEffect(() => {
        // Only trigger if it hasn't popped up in this session yet
        if (!hasAutoPopped) {
            const timer = setTimeout(() => {
                setIsModalOpen(true);
                setHasAutoPopped(true); // Mark as done so it doesn't repeat
            }, 8000); // 8 seconds

            return () => clearTimeout(timer); // Cleanup if user leaves page fast
        }
    }, [hasAutoPopped]);

    const facts = [
        { 
            icon: faExpand, 
            title: "2 Acres", 
            desc: "Expansive Gated Community Spread" 
        },
        { 
            icon: faBuilding, 
            title: "214 Units", 
            desc: "Exclusive 2 BHK Independent Flats" 
        },
        { 
            icon: faLayerGroup, 
            title: "G + 5 Floors", 
            desc: "Low-Density Premium Structure" 
        },
        { 
            icon: faCompass, 
            title: "100% Vaastu", 
            desc: "Designed for Spiritual Harmony" 
        },
        { 
            icon: faShield, 
            title: "No Common Walls", 
            desc: "Total Independence & Privacy" 
        },
        { 
            icon: faLeaf, 
            title: "45% Open Space", 
            desc: "TUDA Approved Green Environment" 
        }
    ];
    



    // ----------------------------------
    // Wellness and clubhouse part
    // ----------------------------------
    const wellnessMasonryImages = [
        {
            title: 'Outdoor Shaded Seating',
            img: desinger_landscape, // Reference to Page 4 landscape render
        },
        {
            title: 'Modern Gymnasium', 
            img: gym, // Reference to Page 5
        },
        {
            title: 'Grand Banquet Hall', 
            img: banquetHall, // Reference to Page 5
        },
        {
            title: 'Indoor Games Arena',
            img: tableGames, // Reference to Page 5
        },
        {
            title: 'Children’s Play Area',
            img: clubhouseImg, // Reference to Page 4
        },
        {
            title: 'Jogging Track',
            img: joggingTrack, // Reference to Page 4
        },
        {
            title: 'Spa & Wellness Room',
            img: spa, // Reference to Page 5
        },
        {
            title: 'Library & Reading Lounge',
            img: libraryRoom, // Reference to Page 5
        },
        {
            title: '24/7 Security System',
            img: securitySystem, // Reference to Page 4
        }
    ];

    // ----------------------------------
    // Care Pillars Section - Updated for CPR MANGALA
    // ----------------------------------
    const carePillars = [
        {
            icon: faHandsPraying,
            tag: "SPIRIT",
            title: "Mindful Serenity",
            items: [
                "Yoga & Meditation Hall",
                "Designer Landscape Gardens",
                "Elder Seating Zones",
                "Vastu-Compliant Architecture"
            ]
        },
        {
            icon: faHeartPulse,
            tag: "HEALTH",
            title: "Active Wellness",
            items: [
                "High-Tech Gymnasium",
                "Swimming Pool & Kids Pool",
                "Jogging & Walking Track",
                "Outdoor Sports Courts"
            ]
        },
        {
            icon: faGlassCheers,
            tag: "LEISURE",
            title: "Social Recreation",
            items: [
                "Grand Double-Height Lounge",
                "Multipurpose Banquet Hall",
                "Indoor Games & Billiards",
                "Rooftop Coffee Shop"
            ]
        }
    ];

    // ----------------------------------
    // Location Section - Updated for Tirupati
    // ----------------------------------
    const locations = [
        { 
            name: "Renigunta Road", 
            time: "02", 
            desc: "Major Commercial Hub", 
            pos: "north" 
        },
        { 
            name: "Tirupati Airport", 
            time: "15", 
            desc: "International Gateway", 
            pos: "east" 
        },
        { 
            name: "Tirupati Rly Station", 
            time: "10", 
            desc: "Central Connectivity", 
            pos: "south" 
        },
        { 
            name: "Sankalpa Hospital", 
            time: "06", 
            desc: "Premium Healthcare", 
            pos: "west" 
        }
    ];


    const MANGALA_AMENITIES = [
        { name: 'Banquet Hall', desc: 'For grand community celebrations', icon: faUsers },
        { name: 'Modern Gym', desc: 'State-of-the-art fitness equipment', icon: faDumbbell },
        { name: 'Indoor Games', desc: 'Table tennis, carroms & board games', icon: faGamepad },
        { name: 'Spa Space', desc: 'Dedicated area for health & wellness', icon: faSpa },
        { name: 'Reception & Lounge', desc: 'Elegant waiting area for guests', icon: faCouch },
        { name: 'Office Room', desc: 'Dedicated community management space', icon: faBriefcase }
    ];

    /**
     * GOOGLE ADS TRACKING (GTAG)
     * This effect manually notifies Google that the user has navigated 
     * to the Mangala page. Since this is a React Single Page App (SPA), 
     * we must "force" a page_view event because the browser doesn't 
     * perform a full page refresh.
     */
    useEffect(() => {
        // We access 'gtag' from the window object (initialized in index.html)
        if (window.gtag) {
            window.gtag('event', 'page_view', {
                page_title: 'CPR Mangala | 2 BHK Independent Flats Tirupati',
                page_path: '/cpr-mangala', // The specific URL path for this project
                send_to: 'AW-17973516848' // Your unique Google Ads ID
            });
        }
    }, []); // The empty array [] ensures this only runs once when the component "mounts"
    
    return(
        <Container fluid className="mangalaPage p-0">
            <MetaHelper 
                title="CPR Mangala | 2 BHK Independent Flats Mangalam Tirupati" 
                description="Affordable luxury at CPR Mangala, Karakambadi Road. No GST, 2 BHK independent flats with zero common walls starting from ₹37 Lakhs."
            />
            <Row id='hero' className='hero-video-section mb-2 g-0'>
                
                <img 
                    src={bannerImg} // Replace with your path to the brochure's main building render
                    alt="CPR Mangala Exterior"
                    className="video hero-img" // Kept class name 'video' to inherit existing styles
                    style={{width: '100%', height: '100vh', objectFit: 'cover'}}
                    loading='lazy'
                />
                <div className='hero-overlay'>
                    <div className='hero-overlay-content w-55 text-center text-lg-end'>
                        {/* Tagline from the brochure front page */}
                        <h3>New Era of Living @Mangalam, Tirupati.</h3>
                        
                        <h1>CPR Mangala</h1>
                        
                        {/* Simplified SEO H6 focused on Renigunta Road */}
                        <h6>
                            Discover premium 2 BHK gated community apartments in Tirupati.
                        </h6>
                        
                        <div className="hero-btn-wrapper mt-4 d-flex justify-content-center justify-content-lg-end">
                            <Button 
                                variant="light" 
                                className="download-brochure-btn px-4 py-2 rounded-pill fw-bold shadow-sm"
                                onClick={handleBrochureClick}
                            >
                                DOWNLOAD BROCHURE 
                                <FontAwesomeIcon icon={faArrowRight} className="ms-2 arrow-icon" />
                            </Button>
                        </div>
                    </div>
                </div>
            </Row>

            <Row id='overview' className="narrative-row g-0 align-items-center bg-white">
                {/* Left Side: Content Column */}
                <Col lg={6} className="narrative-content-col p-5 p-lg-10">
                    <div className="content-wrapper px-md-5">
                        <h6 className="section-subtitle mb-3">THE WORLD OF HAPPINESS</h6>
                        <h2 className="section-title mb-4">Where Elegance Redefines Lifestyle</h2>
                        
                        <p className="narrative-paragraph">
                            Welcome to a new era of urban living at <strong>Mangalam, Tirupati</strong>, where elegance 
                            meets opulence. <strong>CPR Mangala</strong> is a premium <strong>TUDA-approved</strong> gated community 
                            spread across <strong>2 acres</strong>, thoughtfully designed to define perfection in every square foot.
                        </p>

                        <p className="narrative-paragraph">
                            Every residence is crafted as a <strong>Total Independent Home</strong> with zero common walls, 
                            ensuring unmatched acoustic privacy and 3-side natural ventilation. With <strong>45% open spaces</strong>, 
                            this project stands as the most prestigious residential destination on <strong>Karakambadi Road</strong>, 
                            perfectly blending modern architecture with a serene atmosphere.
                        </p>
                    </div>
                </Col>

                {/* Right Side: Image Carousel Column */}
                <Col lg={6} className="narrative-carousel-col">
                    <Carousel fade indicators={true} controls={false} interval={4000} className="h-100">
                        <Carousel.Item className="h-100">
                            <div className="narrative-img-frame">
                                <Image 
                                    src={bannerImg} 
                                    className="w-100 h-100 object-fit-cover" 
                                    alt="CPR Mangala Architecture" 
                                    style={{objectPosition: 'center 20%'}}
                                />
                            </div>
                        </Carousel.Item>
                        <Carousel.Item className="h-100">
                            <div className="narrative-img-frame">
                                <Image 
                                    src={clubhouseImg} 
                                    className="w-100 h-100 object-fit-cover" 
                                    alt="Luxury Clubhouse and Pool" 
                                />
                            </div>
                        </Carousel.Item>
                    </Carousel>
                </Col>
            </Row>
            
            {/* Quick Facts Row */}
            <Row className="quick-facts-row g-0 py-5 bg-light justify-content-center">
                <Col md={10} className="py-5">
                    <div className="text-center mb-5">
                        <h6 className="section-subtitle">PROJECT AT A GLANCE</h6>
                        <h2 className="fw-bold">A New Era of Elegance in Tirupati</h2>
                    </div>
                    <Row className="g-4">
                        {facts.map((fact, index) => (
                            <Col md={4} key={index} className="d-flex align-items-start p-4 fact-card">
                                <div className="fact-icon-box me-3">
                                    <FontAwesomeIcon icon={fact.icon} />
                                </div>
                                <div>
                                    <h5 className="fw-bold mb-1" style={{fontSize: '1.1rem'}}>{fact.title}</h5>
                                    <p className="text-muted mb-0 small">{fact.desc}</p>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Col>
            </Row>

            {/* SECTION 4: THE ARCHITECTURE OF PRIVACY (INDEPENDENT HOMES LOGIC) */}
            <Row id='architecture' className="env-compass-section g-0 py-5 bg-white overflow-hidden">
                <Col lg={12} className="text-center mb-5">
                    <h6 className="section-subtitle">ARCHITECTURAL EXCELLENCE</h6>
                    <h2 className="section-title">Typical Floor Plan</h2>
                    <p className="text-muted">A comprehensive view of the 214 independent units across the 2-acre sanctuary.</p>
                </Col>

                <Container fluid className="px-lg-5">
                    <Row className="align-items-center gy-4">
                        {/* 1. Project Orientation Data */}
                        <Col lg={3} className="order-2 order-lg-1">
                            <div className="info-card mb-4">
                                <h5 className="fw-bold">East Facing Units</h5>
                                <p className="small text-muted mb-0">Premium 860 SFT layouts designed for optimal morning light and Vaastu compliance.</p>
                            </div>

                            <div className="info-card mb-4">
                                <h5 className="fw-bold">North Facing Units</h5>
                                <p className="small text-muted mb-0">855 SFT units positioned along the wide corridors for consistent natural cross-ventilation.</p>
                            </div>

                            <div className="info-card">
                                <h5 className="fw-bold">West Facing Units</h5>
                                <p className="small text-muted mb-0">860 SFT homes capturing the cool evening breeze with zero shared walls for total privacy.</p>
                            </div>
                        </Col>

                        {/* 2. Visual Center: Large Wide Viewport */}
                        <Col lg={6} className="order-1 order-lg-2">
                            <div className="floor-plan-wrapper mangala-wide-static-container">
                                {/* Plain, high-quality image without interactions */}
                                <Image 
                                    src={floorPlanImg} 
                                    alt="CPR Mangala Typical Floor Plan" 
                                    className="static-wide-plan" 
                                />
                            </div>
                        </Col>

                        {/* 3. Tech Specs Column */}
                        <Col lg={3} className="order-3 p-4">
                            <div className="tech-spec-box">
                                <h4 className="fw-bold text-primary-blue">ZERO</h4>
                                <p className="small text-uppercase fw-bold mb-1">Common Walls</p>
                                <p className="text-muted extra-small">Every unit is a standalone structure, ensuring unmatched privacy and 360° air circulation.</p>
                            </div>
                            <div className="tech-spec-box mt-4">
                                <h4 className="fw-bold text-primary-blue">6'6" FT</h4>
                                <p className="small text-uppercase fw-bold mb-1">Wide Corridors</p>
                                <p className="text-muted extra-small">Extra-wide common areas act as the lungs of the community, providing breathing room for all 214 units.</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Row>
            
            {/* --- SECTION 5: THE AMENITIES EDGE (Merged Privacy & Ventilation) --- */}
            <Row id='essentials' className="project-essentials-section g-0 py-5 bg-white">
                <Container className="py-lg-4">
                    <div className="text-center mb-5">
                        <h6 className="section-subtitle">PROJECT ESSENTIALS</h6>
                        <h2 className="section-title">World-Class Infrastructure & Club Luxuries</h2>
                        <p className="text-muted mx-auto w-75">
                            Designed for a new era of living, CPR Mangala integrates high-end recreation 
                            with essential community infrastructure across a 2-acre landscape.
                        </p>
                    </div>

                    <Row className="gy-4 align-items-stretch">
                        {/* 1. The Visual Side: Clubhouse Render (Ref: Page 5) */}
                        <Col lg={6}>
                            <div className="amenity-image-frame h-100 rounded-4 overflow-hidden shadow-sm">
                                <Image 
                                    src={clubhouseImg} 
                                    alt="CPR Mangala Luxury Clubhouse and Amenities" 
                                    className="w-100 h-100 object-fit-cover"
                                />
                                <div className="image-overlay-tag">
                                    <span>~7,144 SQ.FT. CLUBHOUSE</span>
                                </div>
                            </div>
                        </Col>

                        {/* 2. The Data Side: Club Luxuries & Infrastructure */}
                        <Col lg={6}>
                            <div className="essential-card h-100 p-4 p-md-5 bg-white border rounded-4 shadow-sm">
                                <div className="d-flex align-items-center mb-4">
                                    <h4 className="fw-bold mb-0 text-dark">Club Luxuries</h4>
                                </div>
                                
                                {/* Mapping from the MANGALA_AMENITIES constant at top */}
                                <Row className="g-3 mb-5">
                                    {MANGALA_AMENITIES.map((amenity, i) => (
                                        <Col md={6} key={i}>
                                            <div className="amenity-list-item d-flex align-items-start">
                                                <FontAwesomeIcon icon={faCircleCheck} className="text-success mt-1 me-2" />
                                                <div>
                                                    <h6 className="mb-0 fw-bold text-dark small">{amenity.name}</h6>
                                                    <p className="extra-small text-muted mb-0">{amenity.desc}</p>
                                                </div>
                                            </div>
                                        </Col>
                                    ))}
                                </Row>

                                {/* Infrastructure Sub-Section (Ref: Page 4) */}
                                <div className="infra-mini-grid border-top pt-4">
                                    <h5 className="fw-bold text-primary-blue mb-3">Community Infrastructure</h5>
                                    <div className="d-flex flex-wrap gap-3">
                                        <div className="infra-badge">
                                            <FontAwesomeIcon icon={faDroplet} className="me-2 text-cyan" />
                                            Water Softening Plant
                                        </div>
                                        <div className="infra-badge">
                                            <FontAwesomeIcon icon={faShieldHalved} className="me-2 text-cyan" />
                                            Solar Fencing
                                        </div>
                                        <div className="infra-badge">
                                            <FontAwesomeIcon icon={faVideo} className="me-2 text-cyan" />
                                            CCTV Surveillance
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Row>

            {/* --- SECTION 6: THE VERDANT UNIVERSE (Greenery Section) --- */}
            <Row id='greenery' className="interior-showcase-row align-items-center bg-light px-3 px-lg-10 py-5">
                <Col lg={6} className="py-4">
                    <div className="interior-image-card shadow-lg rounded-4 overflow-hidden">
                        <Image 
                            loading='lazy' 
                            src={landscapeGreenery} 
                            className="w-100 h-100 object-fit-cover" 
                            alt="CPR Mangala Designer Landscapes" 
                        />
                    </div>
                </Col>
                <Col lg={6} className="ps-lg-5 py-4">
                    <motion.div 
                        initial={{ opacity: 0, x: 30 }} 
                        whileInView={{ opacity: 1, x: 0 }} 
                        transition={{ duration: 0.8 }}
                    >
                        <h6 className="section-subtitle mb-3">NATURAL HARMONY</h6>
                        <h2 className="section-title mb-4">A Sanctuary of Greenery & Serenity</h2>
                        <p className="narrative-paragraph">
                            Life at <strong>CPR Mangala</strong> is thoughtfully integrated with nature. With 
                            <strong> 45% open spaces</strong> and a <strong>TUDA-approved</strong> layout, the 
                            project offers a peaceful retreat that breathes. 
                        </p>
                        <p className="narrative-paragraph">
                            Surrounded by meticulously planned <strong>Designer Landscapes</strong> and 
                            expansive 30ft+ setbacks, every breath here is fresh. Whether it’s a morning walk 
                            on the dedicated track or a quiet evening in the <strong>Elders' Seating Zone</strong>, 
                            serenity is your new neighbor.
                        </p>
                    </motion.div>
                </Col>
            </Row>

            {/* Clubhouse masonry */}
            <Row id='clubhouse' className='wellness-masonry-grid p-5 bg-white'>
                <Col lg={12} className="text-center mb-5">
                    <motion.h6 
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        className="section-subtitle mb-3"
                    >
                        ~7,144 SQ.FT. LUXURY CLUBHOUSE
                    </motion.h6>

                    <motion.h2 
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.2 }}
                        className="display-5 fw-bold text-primary-blue"
                    >
                        A Universe of Leisure
                    </motion.h2>
                    
                    <motion.p 
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        transition={{ delay: 0.4 }}
                        className="text-muted mx-auto mt-3" 
                        style={{ maxWidth: '700px' }}
                    >
                        Step into a world designed for recreation and elite living. From the 
                        grand banquet hall to the vibrant outdoor courts, every space at 
                        CPR Mangala is crafted for your community experience.
                    </motion.p>
                </Col>
                <Masonry
                    columns={masonryColumns}
                    gutter={16}
                    items={wellnessMasonryImages.map((item, index) => ({
                        key: `item-${index}`,
                        data: item,
                    }))}
                    itemRender={({ data }) => (
                        <div className="wellness-masonry-item">
                            <img 
                                src={`${data.img}?w=523&auto=format`} 
                                alt={data.title} 
                                className="wellness-img" 
                                loading='lazy'
                            />
                            <div className="wellness-overlay">
                                <div className="wellness-overlay-content">
                                    <h4>{data.title}</h4>
                                </div>
                            </div>
                        </div>
                    )}
                />
                <div className='text-end mt-3'><strong>**All images are for illustrative purposes only</strong></div>
            </Row>

            {/* SECTION 8: FEATURED AMENITY SPOTLIGHT - The Clubhouse focus */}
            <Row className="wellness-spotlight-row g-0 bg-white p-5">
                <Container>
                    <Row className="align-items-center">
                        <Col lg={7} className="mb-4 mb-lg-0">
                            <div className="spotlight-image-container">
                                <Image 
                                    src={clubhouseImg} 
                                    className="img-fluid rounded-4 shadow-sm" 
                                    alt="CPR Mangala Luxury Clubhouse" 
                                />
                            </div>
                        </Col>
                        <Col lg={5} className="ps-lg-5">
                            <motion.div
                                initial={{ opacity: 0, x: 20 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.8 }}
                            >
                                <h6 className="section-subtitle mb-2">EXCLUSIVE ACCESS</h6>
                                <h2 className="fw-bold mb-4 text-primary-blue">A Social Sanctuary</h2>
                                <p className="text-muted mb-4">
                                    The heartbeat of CPR Mangala is our dedicated <strong>~7,144 Sq. Ft. Clubhouse</strong>. 
                                    Designed as a G+1 structure, it offers a grand banquet hall for celebrations and 
                                    premium indoor recreation spaces, ensuring a lifestyle of elite social connectivity.
                                </p>
                                <div className="d-flex gap-3">
                                    <div className="mini-stat">
                                        <h4 className="mb-0 fw-bold">7,144</h4>
                                        <small className="text-muted">Square Feet</small>
                                    </div>
                                    <div className="mini-stat">
                                        <h4 className="mb-0 fw-bold">G+1</h4>
                                        <small className="text-muted">Leisure Levels</small>
                                    </div>
                                </div>
                            </motion.div>
                        </Col>
                    </Row>
                </Container>
            </Row>
            
            {/* --- SECTION 9: THE GREEN ACRES --- */}
            <Row className="env-deck-showcase g-0 p-5 bg-light">
                <Container>
                    <Row className="align-items-center">
                        {/* Left Column: Narrative Content */}
                        <Col lg={5} className="order-2 order-lg-1">
                            <motion.div
                                initial={{ opacity: 0, x: -30 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.8 }}
                            >
                                <h6 className="section-subtitle mb-3">OUTDOOR SERENITY</h6>
                                <h2 className="section-title mb-4">A Planet of Verdant Surroundings</h2>
                                <p className="narrative-paragraph">
                                    Spanning an expansive <strong>2-acre spread</strong>, CPR Mangala is engineered for 
                                    maximum breathing room. With <strong>45% open spaces</strong> and wide setbacks, we've 
                                    created a sanctuary where nature is your constant companion.
                                </p>
                                
                                {/* Using your standard list styling with brand-colored icons */}
                                <ul className="deck-features-list list-unstyled mt-4">
                                    <li className="mb-2">
                                        <FontAwesomeIcon icon={faBasketballBall} className="text-primary-blue me-2"/> 
                                        Cricket Practice Pitch & Multipurpose Courts
                                    </li>
                                    <li className="mb-2">
                                        <FontAwesomeIcon icon={faChild} className="text-primary-blue me-2"/> 
                                        Children’s Play Area & Party Lawn
                                    </li>
                                    <li>
                                        <FontAwesomeIcon icon={faWalking} className="text-primary-blue me-2"/> 
                                        Landscaped Walking Track & Elder Seating Zones
                                    </li>
                                </ul>
                            </motion.div>
                        </Col>
                        
                        {/* Right Column: Large Visual with Stat Overlay */}
                        <Col lg={7} className="order-1 order-lg-2 mb-4 mb-lg-0">
                            <div className="deck-visual-wrapper position-relative">
                                <Image 
                                    src={desinger_landscape} 
                                    className="img-fluid rounded-4 shadow-lg w-100" 
                                    alt="CPR Mangala Landscape and Outdoor Spaces" 
                                />
                                <div className="deck-stat-overlay">
                                    <div className="stat-item">
                                        <span>Open Space</span>
                                        <strong>45%</strong>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Row>

            {/* --- SECTION 10: CARE PILLARS (Spirit, Health & Leisure) --- */}
            <Row className="care-pillars-section g-0 py-5">
                <Container className="py-lg-5">
                    <Row className="justify-content-center text-center mb-5">
                        <Col lg={12}>
                            <motion.h6 
                                initial={{ opacity: 0 }}
                                whileInView={{ opacity: 1 }}
                                className="section-subtitle text-cyan mb-2"
                            >
                                A BLESSED LIFESTYLE
                            </motion.h6>
                            <motion.h2 
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                className="fw-bold text-white display-5"
                            >
                                Spirit, Health & Leisure
                            </motion.h2>
                            <motion.p className="text-white-50 mt-3 mx-auto" style={{ maxWidth: '600px' }}>
                                Experience a holistic life at <strong>CPR Mangala</strong>, where thoughtfully 
                                designed spaces nurture your well-being in a secure, TUDA-approved gated community.
                            </motion.p>
                        </Col>
                    </Row>

                    <Row className='gy-4 px-3 px-md-0'>
                        {carePillars.map((pillar, idx) => (
                            <Col lg={4} md={6} key={idx}>
                                <motion.div 
                                    className="pillar-card"
                                    initial={{ opacity: 0, y: 30 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.6, delay: idx * 0.2 }}
                                    viewport={{ once: true }}
                                >
                                    <div className="pillar-header d-flex justify-content-between align-items-start">
                                        <div className="pillar-icon-box">
                                            <FontAwesomeIcon icon={pillar.icon} />
                                        </div>
                                        <span className="pillar-tag">{pillar.tag}</span>
                                    </div>
                                    
                                    <h4 className="pillar-title">{pillar.title}</h4>
                                    
                                    <ul className="pillar-list">
                                        {pillar.items.map((feature, fIdx) => (
                                            <li key={fIdx}>
                                                {feature}
                                            </li>
                                        ))}
                                    </ul>
                                </motion.div>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </Row>



            {/* --- SECTION 11: TECHNICAL SPECIFICATIONS (Ref: Page 12) --- */}
            <Row id="specifications" className="specs-row py-5 bg-white mx-0">
                <Container>
                    <Row className="text-center mb-5">
                        <Col lg={12}>
                            <h6 className="section-subtitle">THE BLUEPRINT OF QUALITY</h6>
                            <h2 className="section-title">Technical Specifications</h2>
                            <p className="text-muted mx-auto" style={{ maxWidth: '600px' }}>
                                Every corner of <strong>CPR Mangala</strong> is built with precision-engineered materials 
                                and premium finishes to ensure lasting luxury.
                            </p>
                        </Col>
                    </Row>
                    
                    <Row className="g-4 align-items-center">
                        {/* Left Side: Image representing the finished quality */}
                        <Col lg={5}>
                            <div className="spec-image-wrapper shadow-lg rounded-4 overflow-hidden">
                                <Image 
                                    src={bannerImgTwo} 
                                    className="img-fluid w-100 h-100 object-fit-cover" 
                                    alt="CPR Mangala Interior Quality" 
                                    style={{ minHeight: '400px' }}
                                />
                            </div>
                        </Col>

                        {/* Right Side: The Technical Details Grid */}
                        <Col lg={7} className="ps-lg-5">
                            <Row className="g-4">
                                <Col md={6}>
                                    <div className="spec-card p-2">
                                        <h5 className="fw-bold border-start border-primary border-3 ps-2 text-uppercase" style={{ fontSize: '1rem', letterSpacing: '1px' }}>Structure</h5>
                                        <p className="small text-muted mb-0">R.C.C. Framed Structure designed to resist wind and seismic loads with <strong>6'6" wide corridors</strong>.</p>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="spec-card p-2">
                                        <h5 className="fw-bold border-start border-primary border-3 ps-2 text-uppercase" style={{ fontSize: '1rem', letterSpacing: '1px' }}>Flooring</h5>
                                        <p className="small text-muted mb-0">Premium 800x800mm Double Charged Vitrified Tiles in all major rooms.</p>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="spec-card p-2">
                                        <h5 className="fw-bold border-start border-primary border-3 ps-2 text-uppercase" style={{ fontSize: '1rem', letterSpacing: '1px' }}>Joinery</h5>
                                        <p className="small text-muted mb-0">Teak wood main door frame with melamine polish and reputed hardware.</p>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="spec-card p-2">
                                        <h5 className="fw-bold border-start border-primary border-3 ps-2 text-uppercase" style={{ fontSize: '1rem', letterSpacing: '1px' }}>Electrical</h5>
                                        <p className="small text-muted mb-0">Concealed copper wiring with modular switches from Legrand/Anchor.</p>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="spec-card p-2">
                                        <h5 className="fw-bold border-start border-primary border-3 ps-2 text-uppercase" style={{ fontSize: '1rem', letterSpacing: '1px' }}>Kitchen</h5>
                                        <p className="small text-muted mb-0">Granite platform with stainless steel sink and power points for modern appliances.</p>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="spec-card p-2">
                                        <h5 className="fw-bold border-start border-primary border-3 ps-2 text-uppercase" style={{ fontSize: '1rem', letterSpacing: '1px' }}>Plumbing</h5>
                                        <p className="small text-muted mb-0">PVC/CPVC piping with premium sanitary ware from Hindware/Parryware.</p>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </Row>



            {/* --- SECTION 12: STRATEGIC LOCATION RADAR (Ref: Page 15) --- */}
            <Row id='location' className="connectivity-section p-5 bg-white overflow-hidden">
                <Container>
                    <Row className="align-items-center">
                        {/* Left Side: Location Narrative */}
                        <Col lg={5}>
                            <motion.h6 
                                initial={{ opacity: 0 }}
                                whileInView={{ opacity: 1 }}
                                className="section-subtitle"
                            >
                                STRATEGIC LOCATION
                            </motion.h6>
                            
                            <h2 className="display-5 fw-bold text-primary-blue">The Star Address</h2>
                            
                            <p className="lead text-muted mt-4">
                                Ideally positioned at <strong>Mangalam (Tirupati)</strong>, CPR Mangala 
                                offers premium connectivity via the vibrant <strong>Karakambadi Road</strong>. 
                                Enjoy effortless access to the city's commercial hubs, prestigious educational 
                                institutions, and major spiritual transit gateways.
                            </p>

                            <div className="investment-badge mt-4 p-4 border-start border-4 border-info bg-light rounded-end">
                                <h5 className="fw-bold mb-1">Developer Trust</h5>
                                <p className="text-muted small mb-2">
                                    A <strong>TUDA-Approved</strong> project by CPR Constructions. 
                                    <br />ISO 9001:2015 Certified Excellence.
                                </p>
                                <div className="d-flex align-items-center gap-2">
                                    <h3 className="fw-extrabold text-primary-blue mb-0">16+</h3>
                                    <small className="text-uppercase tracking-wider fw-bold">Years of Architectural Legacy</small>
                                </div>
                            </div>
                        </Col>

                        {/* Right Side: Radar Connectivity System */}
                        <Col lg={7} className="radar-viewport">
                            <div className="radar-system">
                                {/* The Central Hub: Mangala Logo */}
                                <div className="credence-hub">
                                    <div className="radar-ping"></div>
                                    <div className="radar-ping secondary"></div>
                                    <div className="hub-logo-container">
                                        <Image loading='lazy' src={colorBgLogo} alt="CPR Mangala" style={{ width: '120px' }} />
                                    </div>
                                </div>

                                {/* The Compass Nodes: Mapping Proximity (Data from Page 15) */}
                                {locations.map((loc, index) => (
                                    <motion.div 
                                        key={index}
                                        className={`radar-node ${loc.pos}`}
                                        initial={{ opacity: 0, scale: 0 }}
                                        whileInView={{ opacity: 1, scale: 1 }}
                                        transition={{ delay: index * 0.15, duration: 0.5 }}
                                    >
                                        <div className="node-capsule">
                                            <div className="node-time-hub">{loc.time}m</div>
                                            <div className="node-details">
                                                <h6>{loc.name}</h6>
                                                <p>{loc.desc}</p>
                                            </div>
                                        </div>
                                    </motion.div>
                                ))}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Row>

            {/* --- SECTION 11: CONTACT US --- */}
            <Row id="contact" className="contact-section g-0 py-5 bg-white">
                <Container className="py-5">
                    <Row className="gy-5 align-items-center">
                        {/* Left Side: Project Contact Info */}
                        <Col lg={5}>
                            <motion.div initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} transition={{ duration: 0.8 }}>
                                <h6 className="section-subtitle">GET IN TOUCH</h6>
                                <h2 className="section-title mb-4 text-primary-blue">Visit Your Blessed Abode</h2>
                                <p className="narrative-paragraph mb-5">
                                    Experience the "New Era of Living" firsthand. Our sales gallery at Mangalam is open daily 
                                    to guide you through our ~7,144 SFT clubhouse and premium 2 BHK independent flat layouts.
                                </p>

                                <div className="contact-detail-item d-flex mb-4">
                                    <div className="icon-box me-3 text-primary">
                                        <FontAwesomeIcon icon={faPhoneAlt} /> 
                                    </div>
                                    <div>
                                        <h6 className="fw-bold mb-1">Call for Enquiries</h6>
                                        <div className="d-flex flex-column">
                                            <a href="tel:+919492013322" className="text-decoration-none text-dark fw-bold mb-1">
                                                +91 94920 13322
                                            </a>
                                            <a href="tel:+918374762277" className="text-decoration-none text-dark fw-bold">
                                                +91 83747 62277
                                            </a>
                                            <a href="tel:+918374812277" className="text-decoration-none text-dark fw-bold">
                                                +91 83748 12277
                                            </a>
                                        </div>
                                        <p className="text-muted small mt-1 mb-0">Sales & Site Visit Queries</p>
                                    </div>
                                </div>

                                <div className="contact-detail-item d-flex mb-4">
                                    <div className="icon-box me-3 text-primary"><FontAwesomeIcon icon={faCompass} /></div>
                                    <div>
                                        <h6 className="fw-bold mb-1">Site Address</h6>
                                        <p className="text-muted small">CPR Mangala, Karakambadi Road, Near Mangalam, Tirupati - 517507.</p>
                                    </div>
                                </div>

                                <div className="contact-detail-item d-flex mb-4">
                                    <div className="icon-box me-3 text-primary"><FontAwesomeIcon icon={faBuilding} /></div>
                                    <div>
                                        <h6 className="fw-bold mb-1">Corporate Office</h6>
                                        <p className="text-muted small">CPR Constructions, Renigunta Rd, beside Ankura Hospital, Korramenugunta, Tirupati, AP 517501.</p>
                                    </div>
                                </div>
                            </motion.div>
                        </Col>

                        {/* Right Side: Inquiry Form */}
                        <Col lg={{ span: 6, offset: 1 }}>
                            <motion.div className="contact-form-card p-4 p-md-5 shadow-lg rounded-4" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}>
                                <h4 className="fw-bold mb-4">Request a Call Back</h4>
                                <form onSubmit={handleFormSubmit}>
                                    <Row className="g-3">
                                        <Col md={12}>
                                            <input name="name" type="text" className="form-control custom-input" placeholder="Full Name" value={formData.name} onChange={handleInputChange} required />
                                        </Col>
                                        <Col md={6}>
                                            <input name="email" type="email" className="form-control custom-input" placeholder="Email Address" value={formData.email} onChange={handleInputChange} required />
                                        </Col>
                                        <Col md={6}>
                                            <input 
                                                name="phone" 
                                                type="tel" 
                                                className="form-control custom-input" 
                                                placeholder="Phone Number" 
                                                value={formData.phone} 
                                                onChange={handleInputChange} 
                                                required
                                                pattern='[0-9]{10}'
                                                inputMode='numeric'
                                            />
                                            {/* INLINE ERROR TEXT */}
                                            {formData.phone.length > 0 && formData.phone.length < 10 && (
                                                <small className="text-danger" style={{ fontSize: '10px', display: 'block', marginTop: '2px' }}>
                                                    Must be 10 digits
                                                </small>
                                            )}
                                        </Col>
                                        <Col md={12}>
                                            <select name="interest" className="form-select custom-input" value={formData.interest} onChange={handleInputChange}>
                                                <option value="2 BHK Independent Flat">2 BHK Independent Flat</option>
                                                <option value="Site Visit Request">Schedule a Site Visit</option>
                                                <option value="Pricing Inquiry">Request Price List</option>
                                            </select>
                                        </Col>
                                        <Col md={12}>
                                            <textarea name="message" className="form-control custom-input" rows="4" placeholder="How can we help you?" value={formData.message} onChange={handleInputChange}></textarea>
                                        </Col>
                                        <Col md={12}>
                                            <Button type="submit" disabled={formStatus.type === 'loading'} className="w-100 py-3 mt-2 fw-bold bg-primary-blue border-0 rounded-3 text-white">
                                                {formStatus.type === 'loading' ? 'SENDING...' : 'BOOK A SITE VISIT'}
                                            </Button>
                                            {formStatus.message && (
                                                <div className={`mt-3 small text-center ${formStatus.type === 'error' ? 'text-danger' : 'text-success'}`}>
                                                    {formStatus.message}
                                                </div>
                                            )}
                                        </Col>
                                    </Row>
                                </form>
                            </motion.div>
                        </Col>
                    </Row>
                </Container>
            </Row>

            {/* --- SECTION 12: FOOTER --- */}
            <footer className="bg-dark text-white py-5">
                <Container>
                    <Row className="align-items-center gy-4">
                        <Col lg={4} className="text-center text-lg-start">
                            <Image loading='lazy' src={logo} alt="CPR Mangala Logo" style={{ width: '120px',}} />
                            <p className="mt-3 text-white-50 small">
                                A premium gated community project by CPR Constructions, 
                                offering a new era of urban living at Mangalam, Tirupati.
                            </p>
                        </Col>
                        <Col lg={4} className="text-center">
                            <h6 className="fw-bold mb-3">Quick Links</h6>
                            <div className="d-flex justify-content-center gap-3">
                                <a href="#overview" className="text-white-50 text-decoration-none small">Overview</a>
                                <a href="#architecture" className="text-white-50 text-decoration-none small">Architecture</a>
                                <a href="#clubhouse" className="text-white-50 text-decoration-none small">Clubhouse</a>
                                <a href="#location" className="text-white-50 text-decoration-none small">Location</a>
                                <Link to="/privacy-policy" className="text-white-50 text-decoration-none small">
                                    Privacy Policy
                                </Link>
                            </div>
                        </Col>
                        <Col lg={4} className="text-center text-lg-end">
                            <p className="mb-0 small text-white-50">© 2026 CPR Constructions. All Rights Reserved.</p>
                            <p className="small text-white-50">LP No. 34/2023/1126/TUDA/TPT</p> {/* Example TUDA LP Number */}
                            <p className="mb-0 small" style={{ color: '#888' }}>
                                Designed by <a 
                                    href="https://bixianperformancemarketing.com"
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    style={{ color: '#00d1ff', textDecoration: 'none', fontWeight: '500' }}
                                >
                                    Bixian Performance Marketing
                                </a>
                            </p>
                        </Col>
                    </Row>
                </Container>
            </footer>

            <Modal
                open={isModalOpen}
                onCancel={() => setIsModalOpen(false)}
                footer={null}
                centered
                destroyOnClose={true}
                className="brochure-modal"
            >
                <div className="p-3">
                    <div className="text-center mb-4">
                        <h3 className="fw-bold text-primary-blue">Get the Full Brochure</h3>
                        <p className="text-muted">Enter your details to unlock the project specifications and floor plans.</p>
                    </div>
                    
                    {/* Fixed onSubmit handler */}
                    <form onSubmit={handleBrochureSubmit}>
                        <div className="mb-3">
                            <input name="name" type="text" className="form-control custom-input" placeholder="Full Name" value={formData.name} onChange={handleInputChange} required />
                        </div>
                        <Row className="g-2 mb-3">
                            <Col md={6}>
                                <input name="email" type="email" className="form-control custom-input" placeholder="Email Address" value={formData.email} onChange={handleInputChange} required />
                            </Col>
                            <Col md={6}>
                                <input 
                                    name="phone" 
                                    type="tel" 
                                    className="form-control custom-input" 
                                    placeholder="Phone Number" 
                                    value={formData.phone} 
                                    onChange={handleInputChange} 
                                    required
                                    pattern='[0-9]{10}'
                                    inputMode='numeric'
                                />
                                {/* INLINE ERROR TEXT */}
                                {formData.phone.length > 0 && formData.phone.length < 10 && (
                                    <small className="text-danger" style={{ fontSize: '10px', display: 'block', marginTop: '2px' }}>
                                        Must be 10 digits
                                    </small>
                                )}
                            </Col>
                        </Row>
                        <div className="mb-3">
                            <textarea name="message" className="form-control custom-input" rows="3" placeholder="Any specific requirements? (Optional)" value={formData.message} onChange={handleInputChange}></textarea>
                        </div>
                        <Button 
                            type="submit" 
                            disabled={formStatus.type === 'loading'} 
                            className="w-100 py-3 bg-primary-blue border-0 rounded-pill fw-bold shadow text-white"
                        >
                            {formStatus.type === 'loading' ? 'PROCESSING...' : 'SUBMIT & DOWNLOAD'}
                        </Button>
                    </form>
                </div>
            </Modal>


            {/* FLOATING ACTION BUTTONS */}
            <FloatButton.Group
                trigger="hover"
                type="primary"
                style={{ insetInlineEnd: 24, bottom: 24 }}
                icon={<FontAwesomeIcon icon={faCompass} />} // Using your project's theme icon
            >

                {/* Call Button */}
                <FloatButton 
                    icon={<PhoneOutlined />} 
                    href="tel:+919492013322"
                    tooltip={<div>Call Sales Team</div>}
                />


                {/* WhatsApp Button - Using official brand color */}
                <FloatButton 
                    icon={<WhatsAppOutlined />} 
                    target="_blank"
                    href="https://wa.me/+919010403065" // Replace with actual WhatsApp number
                    tooltip={<div>WhatsApp Us</div>}
                    style={{ backgroundColor: '#25D366', color: '#fff' }} 
                />

                {/* Back to Top - Specialized button that handles scrolling automatically */}
                <FloatButton.BackTop 
                    tooltip={<div>Scroll to Top</div>} 
                />
            </FloatButton.Group>
        </Container>
    )
};

export default MangalaPage;